module.exports = __webpack_public_path__ + "img/carousel-right.dc610887.png";